import { render, staticRenderFns } from "./smallHeader.vue?vue&type=template&id=53599508&scoped=true"
import script from "./smallHeader.vue?vue&type=script&lang=js"
export * from "./smallHeader.vue?vue&type=script&lang=js"
import style0 from "./smallHeader.vue?vue&type=style&index=0&id=53599508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53599508",
  null
  
)

export default component.exports